import dayjs from "@/lib/helpers/dayjs";
import type { DraftNote } from "@/core/types";

export function adaptDraftNoteData(notes: DraftNote[]) {
  return notes
    .map((note) => {
      const updatedTimestamp = note.updated_date ?? note.created_date;

      return {
        dateOfService: dayjs(
          `${note.session_date} ${note.session_from}`,
          "MM/DD/YYYY HH:mm",
        ).format("MM/DD/YYYY hh:mma"),
        id: note.id,
        lastUpdated: dayjs.unix(updatedTimestamp).format("MM/DD/YYYY hh:mma"),
        name: `${note.patient_first_name} ${note.patient_last_name}`,
        noteState: note.note_state,
        patientId: note.patient_id,
      };
    })
    .sort(
      (a, b) =>
        dayjs(b.dateOfService, "MM/DD/YYYY hh:mma").valueOf() -
        dayjs(a.dateOfService, "MM/DD/YYYY hh:mma").valueOf(),
    );
}

export type AdaptedDraftNote = ReturnType<typeof adaptDraftNoteData>[number];
